import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { InputFieldFormProperty } from '../../../../../external/UIFormClient/infrastructure/ui/InputFieldFormProperty';
import { IUserMoveForm } from '../../interfaces';

export interface IUserMoveFormTemplate {
  properties: UIFormClient<IUserMoveForm>['properties'];
}

export abstract class UserMoveFormTemplate {
  public compose(): IUserMoveFormTemplate {
    return {
      properties: {
        username: InputFieldFormProperty.create(undefined, {
          initialValue: '',
          isDisplayable: false,
          isEditable: false,
        }),
        confirmUsername: InputFieldFormProperty.create(undefined, {
          initialValue: '',
          isDisplayable: true,
          isEditable: true,
        }),
        existingTenantUuid: InputFieldFormProperty.create(undefined, {
          initialValue: '',
          isDisplayable: false,
          isEditable: false,
        }),
        targetTenantUuid: InputFieldFormProperty.create(undefined, {
          initialValue: '',
          isDisplayable: false,
          isEditable: false,
        }),
        targetTenantName: InputFieldFormProperty.create(undefined, {
          initialValue: '',
          isDisplayable: true,
          isEditable: false,
        }),
      },
    };
  }
}
